import { render, staticRenderFns } from "./EditMasterArtikelComponent.vue?vue&type=template&id=b9daa5e4&"
import script from "./EditMasterArtikelComponent.vue?vue&type=script&lang=js&"
export * from "./EditMasterArtikelComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports